webpackJsonp([0],{

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {


    var React = __webpack_require__(15);
    var createReactClass = __webpack_require__(45);
    var PageRenderer = __webpack_require__(289).PageRenderer;
    if (PageRenderer.__esModule) {
      PageRenderer = PageRenderer.default;
    }
    var WrappedPageRenderer = createReactClass({
      displayName: 'WrappedPageRenderer',
      getInitialState: function() {
        return {content: __webpack_require__(784)};
      },
      componentWillMount: function() {
        var component = this;
        if (false) {
          module.hot.accept("!!./node_modules/raw-loader/index.js!./README.md", function() {
            component.setState({
              content: require("!!./node_modules/raw-loader/index.js!./README.md")
            })
          })
        }
      },
      render: function() {
        return React.createElement(PageRenderer, Object.assign({}, this.props, {content: this.state.content}));
      }
    });
    WrappedPageRenderer.__catalog_loader__ = true;
    module.exports = WrappedPageRenderer;
  

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

module.exports = "# React Device Kit\na collection of devices written in React "

/***/ })

});


// WEBPACK FOOTER //
// static/0.7e4f99b1.chunk.js